import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import MemberToBuckets from './members/MemberToBuckets';
import Actions from '../containers/organizationBuckets/Actions';

class AddUserToBuckets extends React.Component {
    constructor(props) {
        super(props);

        let bucketIds = [];
        let bucketName = '';

        this.state = {
            bucketIds,
            bucketName,
        };
    }

    onCheckBuckets = bucketIds => {
        this.setState({ bucketIds });
    };

    onAddUserToBuckets = () => {
        const { bucketIds } = this.state;
        const { users, onSubmit } = this.props;

        const memberIds = users.map(user => {
            return user.id;
        });
        onSubmit({ memberIds, bucketIds });
    };

    render() {
        const { classes, isOpen, closeDialog } = this.props;
        return (
            <Dialog
                open={isOpen}
                onClose={closeDialog}
                className={classes.wrapper}
            >
                <DialogTitle>Assign To Project</DialogTitle>
                <DialogContent id="scroll-wrapper">
                    <Actions />
                    <MemberToBuckets
                        checkBuckets={this.onCheckBuckets}
                        bucketIds={this.state.bucketIds}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDialog}>CANCEL</Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this.onAddUserToBuckets}
                        disabled={this.state.bucketIds.length === 0}
                    >
                        CONFIRM
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

AddUserToBuckets.propTypes = {
    classes: PropTypes.object,
    users: PropTypes.array,
    isOpen: PropTypes.bool.isRequired,
    closeDialog: PropTypes.func.isRequired,
};

AddUserToBuckets.defaultProps = {
    users: [],
};

const style = () => ({
    wrapper: {
        maxHeight: 850,
        top: '15%',
    },
});

export default injectSheet(style)(AddUserToBuckets);



// WEBPACK FOOTER //
// ./src/components/AddUserToBuckets.js